import React from 'react';
import { Dialog } from '@headlessui/react';

export default function Modal({ title, children, onClose, busy = false, wide = false }: {
  title: React.ReactNode; children: React.ReactNode; onClose: () => void; busy?: boolean; wide?: boolean;
}) {
  return <Dialog open onClose={() => { if (!busy) onClose(); }} className="relative z-50">
    <div className="fixed inset-0 bg-gray-900/50" aria-hidden="true" />
    <div className="fixed inset-0 overflow-y-auto p-4 sm:p-6"><div className="flex min-h-full items-center justify-center">
      <Dialog.Panel className={`w-full rounded-xl bg-white p-5 shadow-xl sm:p-6 ${wide ? 'max-w-4xl' : 'max-w-lg'}`} aria-busy={busy}>
        <div className="mb-5 flex items-start justify-between gap-4">
          <Dialog.Title className="text-lg font-semibold text-gray-900">{title}</Dialog.Title>
          <button type="button" aria-label="Dialog schließen" onClick={onClose} disabled={busy} className="rounded-lg p-1 text-gray-500 hover:bg-gray-100 disabled:opacity-50">✕</button>
        </div>
        {children}
      </Dialog.Panel>
    </div></div>
  </Dialog>;
}
